import { render, staticRenderFns } from "./Nueva-caja.vue?vue&type=template&id=58fc949e&scoped=true"
import script from "./Nueva-caja.vue?vue&type=script&lang=js"
export * from "./Nueva-caja.vue?vue&type=script&lang=js"
import style0 from "./Nueva-caja.vue?vue&type=style&index=0&id=58fc949e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc949e",
  null
  
)

export default component.exports